
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/smart-gateway",
      function () {
        return require("private-next-pages/smart-gateway/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/smart-gateway"])
      });
    }
  